import { useOrg } from "@/lib/states/session/hooks";
import { trpc } from "@/lib/trpc/client";

export function useOrgFeatureFlags() {
  const org = useOrg();
  const { data } = trpc.features.orgFlags.useQuery(undefined, {
    enabled: Boolean(org?.id),
  });

  return {
    aiWorkoutBuilder: data?.aiWorkoutBuilder ?? false,
    aiCheckinSummary: data?.aiCheckinSummary ?? false,
  };
}
